/* eslint-disable import/prefer-default-export */
import config from '@/const/config';
import { cacheByTime } from '../utils';
import { easyPost } from './utils';

const one = () => ({
  issueTime: Date.now(),
  pointAmount: (Math.random() * 10).toFixed(2),
  pointName: '积分模拟',
});

const isMock = false;

function mock(no = false) {
  return function anonymous() {
    return Promise.resolve(
      no
        ? {
          data: [one(), one(), one(), one(), one(), one(), one()],
        }
        : {
          code: 0,
          data: {
            data: [one(), one(), one(), one(), one(), one(), one()],
          },
        },
    );
  };
}

//  用户积分信息
export const getBountyBasicInfo = easyPost('user.taurus.pointInfo');

//  积分发放记录
export const getBountyEarnRecords = isMock
  ? mock()
  : easyPost('user.taurus.issueRecords');

//  积分支出记录
export const getBountyConsumeRecords = isMock
  ? mock()
  : easyPost('user.taurus.consumeRecords');

// 积分已过期记录
export const getBountyExpiredRecords = isMock
  ? mock(true)
  : easyPost('user.taurus.expired');

// 兑换商品列表
export const getBountyExchangeList = easyPost('mall.goods.searchBonusNew', {
});

// 商品详情
export const getAwardDetail = easyPost('coupon.virtual.detail');

// 兑换下单
export const purchaseAward = easyPost('mall.goods.purchase', {
  noCatch: true,
});

// 新版兑换下单
export const purchaseAwardV2 = easyPost('common.welfare.exchangeGoods', {
  noCatch: true,
});

// 任务列表
export const getTaskList = easyPost('activity.jianglijin.listActivities', {
  api: config.MARKET_API,
});

// 任务列表
export const getTaskListV2 = cacheByTime((...args) => easyPost('common.welfare.taurus.task')(
  ...args,
), 500);

// 任务列表
export const acceptTaskV2 = easyPost('mars.task.acceptTaskList', {
  api: config.MARKET_API,
});

// 获取任务奖励
export const getTaskAward = easyPost('mars.offer.receiveAward', {
  api: config.MARKET_API,
});

// 获取外部权益
export const externalEquity = easyPost('welfare.bounty.external.equity', {
});

export const bountyExchangeTab = easyPost('common.business.bountyExchangeTab', {
});

export const receiveActivityCoupon = easyPost('moon.scene.award', {
  api: config.MARKET_API,
});

// 取消订单
export const declineCouponOrder = easyPost('coupon.order.decline');

// 吃饭补贴详情
export const getSubsidyDetail = easyPost('common.welfare.subsidy.detail', {
  risk: true,
});

// 吃饭补贴提醒开关
export const setSubsidyNotice = easyPost('common.welfare.subsidy.notice');
